import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';

export interface NavTileStat {
  labelKey: string;
  value: number;
}

@Component({
  selector: 'app-nav-tile',
  imports: [TranslatePipe, MatIcon],
  templateUrl: './nav-tile.component.html',
  styleUrl: './nav-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavTileComponent {
  private router = inject(Router);

  link = input.required<string>();
  icon = input.required<string>();
  titleKey = input<string>('');
  titleText = input<string | undefined>(undefined);
  subtitleKey = input.required<string>();
  stats = input<NavTileStat[]>([]);
  testId = input.required<string>();

  open(): void {
    void this.router.navigateByUrl(this.link());
  }
}
